import { _isNullOrUndefined } from '../utils';
import { _Inflater } from './inflater';
export class _DeflateStream {
    constructor(data, offset, leaveOpen) {
        if (_isNullOrUndefined(data)) {
            this._data = data;
        }
        else {
            this._data = [];
        }
        if (_isNullOrUndefined(leaveOpen)) {
            this._leaveOpen = leaveOpen;
        }
        this._offset = offset;
        this._inflater = new _Inflater();
        this._buffer = Array(8192).fill(0);
    }
    _read(array, offset, count) {
        let length;
        let cOffset = offset;
        let rCount = count;
        while (true) { // eslint-disable-line
            const inflateResult = this._inflater._inflate(array, cOffset, rCount);
            length = inflateResult.count;
            array = inflateResult.data;
            cOffset += length;
            rCount -= length;
            if (rCount === 0) {
                break;
            }
            if (this._inflater._finished) {
                break;
            }
            const result = this._readBytes();
            const bytes = result.count;
            this._buffer = result.buffer;
            if (bytes === 0) {
                break;
            }
            this._inflater._setInput(this._buffer, 0, bytes);
        }
        return { count: count - rCount, data: array };
    }
    _readBytes() {
        if (_isNullOrUndefined(this._offset) && this._offset >= this._data.length) {
            return { buffer: [], count: 0 };
        }
        else {
            let count = 0;
            for (let i = 0; i < this._buffer.length && i + this._offset < this._data.length; i++) {
                this._buffer[i] = this._data[this._offset + i];
                count++;
            }
            this._offset += count;
            return { buffer: this._buffer, count: count };
        }
    }
}
